import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { PasswordStrengthMeterModule } from 'angular-password-strength-meter';
import { SharedModule } from 'src/app/shared/shared.module';
import { NavigationModule } from '../navigation/navigation.module';
import { LanguageSelectComponent } from './components/language-select/language-select.component';
import { MobileOtherActionsComponent } from './components/mobile-other-actions/mobile-other-actions.component';
import { PasswordRequirementsComponent } from './components/password-requirements/password-requirements.component';
import { RenewPasswordComponent } from './components/renew-password/renew-password.component';
import { ResetPasswordDialogComponent } from './components/reset-password-dialog/reset-password-dialog.component';
import { SignedInLayoutComponent } from './components/signed-in-layout/signed-in-layout.component';
import { SignedInStartRedirectComponent } from './components/signed-in-start-redirect/signed-in-start-redirect.component';
import { TopBarComponent } from './components/top-bar/top-bar.component';
import { UserActionsComponent } from './components/user-actions/user-actions.component';
import { WhatsNewComponent } from './components/whats-new/whats-new.component';
import { ActionHandlerComponent } from './pages/action-handler/action-handler.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { AccessPendingComponent } from './pages/access-pending/access-pending.component';
import { EstateQrPageComponent } from './pages/estate-qr-page/estate-qr-page.component';
import { PublicDefectStatusPageComponent } from './pages/public-defect-status-page/public-defect-status-page.component';
import { ContextResolver } from './services/context.resolver';
import { CompanySelectComponent } from './components/company-select/company-select.component';
import { LogoSvgComponent } from './components/logo-svg/logo-svg.component';
import { SwitchContextComponent } from './components/switch-context/switch-context.component';
import { BrowserNtfPanelComponent } from './components/browser-ntf-panel/browser-ntf-panel.component';

@NgModule({
  declarations: [
    SignedInLayoutComponent,
    SignedInStartRedirectComponent,
    SignInComponent,
    TopBarComponent,
    UserActionsComponent,
    RenewPasswordComponent,
    MobileOtherActionsComponent,
    ResetPasswordDialogComponent,
    ActionHandlerComponent,
    AccessPendingComponent,
    EstateQrPageComponent,
    PublicDefectStatusPageComponent,
    PasswordRequirementsComponent,
    WhatsNewComponent,
    LanguageSelectComponent,
    CompanySelectComponent,
    LogoSvgComponent,
    SwitchContextComponent,
    BrowserNtfPanelComponent
  ],
  imports: [
    SharedModule,
    RouterModule,
    MatSidenavModule,
    NavigationModule,
    MatDialogModule,
    PasswordStrengthMeterModule.forRoot()
  ],
  providers: [ContextResolver]
})
export class UserContextModule {}
